import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TimeWindowSelectorPageRoutingModule } from './time-window-selector-routing.module';

import { TimeWindowSelectorPage } from './time-window-selector.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TimeWindowSelectorPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [TimeWindowSelectorPage],
})
export class TimeWindowSelectorPageModule {}
